/**
 *
 * @param $location
 * @param testModeTestAutoFillData
 * @constructor
 */
let TestModeService = function (
    $location,
    testModeTestAutoFillData
) {
    let self = this;

    /**
     * Returns true if url contains "?test"
     * @returns {boolean|*}
     */
    self.urlContainsTestModeEnablerParam = function () {
        let queryParams = $location.search();
        return Boolean(queryParams.test);
    };

    /**
     *
     * @param noLongerUsed
     * @param def
     * @param params
     * @return {*}
     */
    self.getTestData = function (noLongerUsed, def, params) {
        return testModeTestAutoFillData.getTestData(params);
    };
};

/**
 * {TestModeService}
 */
angular.module('testMode').service(
    'testModeService',
    [
        '$location',
        'testModeTestAutoFillData',
        function (
            $location,
            testModeTestAutoFillData
        ) {
            return new TestModeService(
                $location,
                testModeTestAutoFillData,
                false
            );
        },
    ]
);
